// tokenReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	sitesInformation: [],
};

const groupSites = createSlice({
	name: 'siteGroups', // Use the same name as in your store configuration
	initialState,
	reducers: {
		setSitesInformation: (state, action) => {
			state.sitesInformation = action.payload;
		},
	},
});

export const { setSitesInformation } = groupSites.actions;
export default groupSites.reducer;
